import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { getContents } from 'store/contents/selectors';
import { isLowResolution } from 'store/app/selectors';
import { RootAppState } from 'store/types';
import TabBar from 'components/common/TabBar';
import Accordion from 'components/common/Accordion';

type HowToProps = {
  content: string;
  inverted: boolean;
  childrenElements: any[];
  linkTabIndex?: number;
};

class HowTo extends React.PureComponent<HowToProps & ConnectedProps<typeof connector>> {
  render() {
    const { childrenContents, content, inverted, isTablet, linkTabIndex } = this.props;
    return (
      (isTablet && (
        <Accordion
          content={content}
          inverted={inverted}
          childrenContents={childrenContents}
        ></Accordion>
      )) || (
        <TabBar
          content={content}
          inverted={inverted}
          childrenContents={childrenContents}
          linkTabIndex={linkTabIndex}
        ></TabBar>
      )
    );
  }
}

function mapStateToProps(state: RootAppState, ownProps: HowToProps) {
  return {
    childrenContents: getContents(state, ownProps.childrenElements),
    isTablet: isLowResolution(state)
  };
}

const connector = connect(mapStateToProps);
export default connector(HowTo);
